import React from 'react';
import { withSessionSsr, getPublicToken } from "../../lib/sessionMiddleware";
import { getCanonicalPath } from "../../lib/canonical";
import {
  Wrapper,
  TituloSeccion,
  SubtituloSeccion,
  Seccion,
  Footer,
  HeadTags,
  BtnFlotanteWhatsapp,
  ItemTematica,
  Navbar,
}from '../../components';
import styles from './styles.module.scss';

const TematicasPage = (props)=>{

  const tematicas = props.pageProps.tematicas;

  return(<>

    <HeadTags  
      title="Todas las temáticas" 
      description="¡Encontrá esa temática que tanto estas buscando!"
      path={props.pageProps.pathname}
    />

    <Navbar/>

    <Seccion padding="40px 20px" paddingMobile="20px">
      <Wrapper>
        <TituloSeccion align="center">Temáticas</TituloSeccion>
        {/* <br/> */}
        {/* <SubtituloSeccion align="center">¡Encontrá esa temática que tanto estas buscando!</SubtituloSeccion> */}
        <br/><br/>
        <div className={styles.grid}>
          {tematicas?.map(item=>(
            <ItemTematica data={item} key={item.id} />
          ))}
        </div>
      </Wrapper>
    </Seccion>

    <br/><br/><br/>
        
    <Footer/>
 
    <BtnFlotanteWhatsapp/>
  </>);
};

export default TematicasPage;

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {
  
    const { req } = ctx;
        
    const publicToken = await getPublicToken(req);
    const fetchTematicas = async()=>{
      // let body = {}
      try{
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/tematicas/get-filtered`, {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
          // body: JSON.stringify(body)
        });
        let data = await result.json();
        // console.log("tematicas", data.data)
        return (data?.data || []);
      }catch(err){
        console.log("e", err);
        return [];
      }     
    };

    let tematicas = await fetchTematicas();

    return {
      props: {
        pathname: getCanonicalPath(req),
        tematicas: tematicas,
      },
    };    
  
  },
);